import { createContext } from "react";
import {
  FieldValues,
  FormState,
  UseFormGetValues,
  UseFormHandleSubmit,
  UseFormRegister,
  UseFormSetValue,
  UseFormReset,
  UseFormWatch,
  Control,
  FieldErrors,
} from "react-hook-form";

type ICommonFormContext = {
  register: UseFormRegister<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  formState: any;
  handleSubmit: UseFormHandleSubmit<FieldValues, undefined>;
  reset: UseFormReset<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  control: Control<FieldValues>;
  errors: FieldErrors<FieldValues>; // ✅ 에러 필드 추가
};

export const CommonFormContext = createContext<ICommonFormContext | undefined>(
  undefined
);
